/* eslint-disable ember/no-classic-components, ember/require-tagless-components */
import { action } from '@ember/object';
import Component from '@ember/component';
import NSWStatus from '@linc-technologies/linced-common/enums/nsw-status';

export default class LocationRestore extends Component {
  location = null;
  close = null;
  saveAndClose = null;

  @action
  restore() {
    this.location.set('status', NSWStatus.ACTIVE);
    this.saveAndClose();
  }
}
